import {
  MANUAL_TEMPLATE_ID,
  MANUAL_TEMPLATE_NAME,
} from "constants/sundryTemplates";
import { sortBy } from "lodash";

export const buildSundryTemplateOptions = (
  sundryTemplates: SundryTemplate[],
): SelectFieldOption[] => {
  const sundryTemplateOptions: SelectFieldOption[] = sortBy(
    sundryTemplates.map(sundryTemplate => ({
      label: sundryTemplate.name,
      value: sundryTemplate.id,
    })),
    "label",
  );
  return sundryTemplateOptions.concat({
    label: MANUAL_TEMPLATE_NAME,
    value: MANUAL_TEMPLATE_ID,
  });
};
